import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'button-group',
  templateUrl: './button-group.component.html',
  styleUrl: './button-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ButtonGroupComponent {

}
